/**
 * Normalize priority tag between descriptive and P values
 * @param {string} priorityTag - Priority tag to normalize
 * @param {boolean} isLegacyMode - Whether in legacy mode
 * @returns {string} - Normalized priority tag
 */
function normalizePriorityTag(priorityTag, isLegacyMode = false) {
	if (priorityTag == null || priorityTag === '') return priorityTag;
	const trimmed = typeof priorityTag === 'string' ? priorityTag.trim() : String(priorityTag).trim();
	if (!trimmed) return priorityTag;

	// Map descriptive levels to P values
	const descriptiveToP = {
		"Foundational (Level 1)": "P1",
		"Hygiene (Level 2)": "P2",
		"Governed (Level 3)": "P3",
		"Controlled (Level 4)": "P4",
		"Monitored (Level 5)": "P5"
	};

	// Map P values to descriptive levels
	const pToDescriptive = {
		"P1": "Foundational (Level 1)",
		"P2": "Hygiene (Level 2)",
		"P3": "Governed (Level 3)",
		"P4": "Controlled (Level 4)",
		"P5": "Monitored (Level 5)"
	};

	// "Level N" shorthand (e.g. from API) -> full descriptive
	const levelToDescriptive = {
		"Level 1": "Foundational (Level 1)",
		"Level 2": "Hygiene (Level 2)",
		"Level 3": "Governed (Level 3)",
		"Level 4": "Controlled (Level 4)",
		"Level 5": "Monitored (Level 5)"
	};

	// If in legacy mode, convert descriptive to P values
	if (isLegacyMode) {
		return descriptiveToP[trimmed] || trimmed;
	}
	// If not in legacy mode, convert P values to descriptive; accept descriptive or "Level N" as-is/canonical
	return pToDescriptive[trimmed] || levelToDescriptive[trimmed] || trimmed;
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = normalizePriorityTag;
} else if (typeof window !== 'undefined') {
	window.normalizePriorityTag = normalizePriorityTag;
}
